import React, { useState, useEffect, useRef } from "react";
import styles from "./carManage.module.css";
import upload from "../../assets/icons/upload.png";
import { BarLoader } from "react-spinners";

function removeItems(arr, item) {
  for (var i = 0; i < item; i++) {
    arr.pop();
  }
}

function useFiles({ initialState = [], maxFiles }) {
  const [state, setstate] = useState(initialState);
  function withBlobs(files) {
    const destructured = [...files];
    if (destructured.length > maxFiles) {
      const difference = destructured.length - maxFiles;
      removeItems(destructured, difference);
    }
    const blobs = destructured
      .map((file) => {
        if (file.type.includes("image")) {
          file.preview = URL.createObjectURL(file);
          return file;
        }
        return null;
      })
      .filter((elem) => elem !== null);

    setstate(blobs);
  }
  return [state, withBlobs];
}

function Upload({ onDrop, maxFiles = 1, imageUploadLoader }) {
  const [over, setover] = useState(false);
  const [files, setfiles] = useFiles({ maxFiles });
  const [uploaded, setUploaded] = useState(false);

  const $input = useRef(null);
  useEffect(() => {
    if (onDrop) {
      onDrop(files);
    }
  }, [files]);
  return (
    <>
      <div
        onClick={() => {
          $input.current.click();
          setUploaded(true);
        }}
        onDrop={(e) => {
          e.preventDefault();
          e.persist();
          setfiles(e.dataTransfer.files);
          setover(false);
          setUploaded(true);
        }}
        onDragOver={(e) => {
          e.preventDefault();
          setover(true);
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          setover(false);
        }}
        className={styles.dragAndDrop}
      >
        <div className={styles.dragAndDrop}>
          {!uploaded && (
            <>
              <img src={upload} alt="upload" />
              <h2>
                Drag and drop files, or <span className="blue"> Browse</span>
              </h2>
              <p>Please upload transparent image of car</p>
            </>
          )}

          {uploaded && (
            <div className="blob-container">
              {/* <h2>File Previews</h2> */}
              {files.map((file) => (
                <img
                  key={file.name + "file"}
                  src={file.preview}
                  alt="your file"
                />
              ))}

              {imageUploadLoader && (
                <div className="a">
                  <BarLoader height={"20px"} color="#031569" />
                </div>
              )}
              {/* <p>{JSON.stringify(files.length)}</p> */}
            </div>
          )}
        </div>

        <input
          style={{ display: "none" }}
          type="file"
          accept="image/*"
          ref={$input}
          onChange={(e) => {
            setfiles(e.target.files);
          }}
          multiple={maxFiles > 1}
        />
      </div>
    </>
  );
}

export { Upload };
